// extracted by mini-css-extract-plugin
module.exports = {"thumb":"thumb-23MYJ","routeContainer":"routeContainer-14nrM","details":"details-33ga8","name":"name-1i7KV"};